import { useState } from "react";
import { ChevronDown, SlidersHorizontal } from "lucide-react";

export function Card({ children, className = "", ...p }) { return <div className={`bg-white rounded-2xl border border-[#EBE8E3] ${className}`} {...p}>{children}</div>; }

export function SectionTitle({ icon: Icon, n, title, right }) {
  return (
    <div className="flex items-center justify-between gap-3 mb-4">
      <h2 className="text-base font-semibold text-[#1A1919] flex items-center gap-2.5"><span className="h-7 w-7 rounded-full bg-[#F1EAE4] text-[#A83232] text-xs font-bold flex items-center justify-center">{n}</span><Icon className="h-4 w-4 text-[#806B61]" /> {title}</h2>
      {right}
    </div>
  );
}

export function FileRow({ fl, href, onDelete, disabled, testid }) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-[#EBE8E3] px-3 py-2" data-testid={testid}>
      <a href={href} target="_blank" rel="noreferrer" className="text-sm text-[#1A1919] hover:underline truncate flex-1">{fl.original_filename}</a>
      <span className="text-xs text-stone-400 shrink-0">{Math.max(1, Math.round((fl.size || 0) / 1024))} KB</span>
      <a href={href} target="_blank" rel="noreferrer" className="text-xs text-stone-400 hover:text-[#806B61]">Download</a>
      {onDelete && <button type="button" onClick={onDelete} disabled={disabled} data-testid={`${testid}-delete`} className="text-xs text-stone-400 hover:text-[#A83232]">Fjern</button>}
    </div>
  );
}

/** Fælles to-kolonne-layout: panel til højre (desktop) / lige under header og foldbart (mobil). */
export function DetailGrid({ panel, panelTestid = "detail-panel", children }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="flex flex-col gap-5 lg:grid lg:grid-cols-[minmax(0,1fr)_340px] lg:items-start">
      <Card className="lg:order-2 lg:sticky lg:top-4" data-testid={panelTestid}>
        <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-5 py-3.5 lg:cursor-default" data-testid={`${panelTestid}-toggle`}>
          <span className="text-base font-semibold text-[#1A1919] flex items-center gap-2"><SlidersHorizontal className="h-4 w-4 text-[#806B61]" /> Handlingspanel</span>
          <ChevronDown className={`h-4 w-4 text-stone-400 transition-transform lg:hidden ${open ? "rotate-180" : ""}`} />
        </button>
        <div className={`px-5 pb-5 space-y-4 ${open ? "" : "hidden lg:block"}`}>{panel}</div>
      </Card>
      <div className="space-y-5 lg:order-1 min-w-0">{children}</div>
    </div>
  );
}
